import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a7c15ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "execirse-box"
};
const _hoisted_2 = {
  class: "execirse-title"
};
const _hoisted_3 = {
  class: "title-order"
};
const _hoisted_4 = {
  class: "title-content"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  class: "download"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附件：", -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "attachment-name"
};
const _hoisted_10 = {
  key: 1,
  class: "execirse-options-item"
};
const _hoisted_11 = {
  class: "option-box"
};
const _hoisted_12 = {
  class: "option-label"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 2,
  class: "execirse-options-item"
};
const _hoisted_15 = {
  class: "option-box"
};
const _hoisted_16 = {
  class: "option-label"
};
const _hoisted_17 = ["innerHTML"];
import { reactive, onMounted, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { ATTACHMENT_ICON, ATTACHMENT_COLOR } from '@/utils/constance';
import { getDownloadFile } from '@/api/preview';
export default {
  __name: 'index',
  props: {
    canAnswer: {
      type: Boolean,
      default: false
    },
    questionList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['handleToAnswer'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const EXECIRSE_TYPE = {
      EXAM_QU_TYPE_OBJ_SELECT_SINGLE: '【单选题】',
      // 单选
      EXAM_QU_TYPE_OBJ_SELECT_MULTIPLE: '【多选题】',
      // 多选
      EXAM_QU_TYPE_OBJ_SELECT_JUDGE: '【判断题】' // 判断题
    };

    const state = reactive({
      questionList: props.questionList || [],
      // 题的数组
      resource: [],
      // 每一道题的值
      questionArrText: [],
      // 答题保存的数组
      canAnswer: props.canAnswer
    });
    watch(() => props.questionList, val => {
      state.questionList = val;
      fetchExecireseList();
    });
    watch(() => props.canAnswer, val => {
      state.canAnswer = val;
      fetchExecireseList();
    });
    const ruleFormRef = ref(null);
    const NumToAbc = value => {
      return String.fromCharCode(65 + parseInt(value));
    };
    onMounted(() => {
      fetchExecireseList();
    });
    const fetchExecireseList = () => {
      for (let i = 0; i < state.questionList.length; i++) {
        if (state.questionList[i].type === 'EXAM_QU_TYPE_OBJ_SELECT_MULTIPLE') {
          state.resource[i] = [];
        } else {
          state.resource[i] = '';
        }
      }
    };
    const changeOption = (val, index) => {
      console.log(val, index);
    };
    const submitForm = () => {
      state.questionArrText = state.questionList;
      ruleFormRef.value.validate(valid => {
        if (valid) {
          const nonEmptyElements = state.resource.filter(elem => elem.length > 0);
          if (nonEmptyElements.length !== state.questionArrText.length) {
            // 有题目未答
            ElMessage.error('请答完所有题目再提交！');
          } else {
            handleToAnswer();
          }
        }
      });
    };
    const handleToAnswer = () => {
      state.questionArrText = state.questionList;
      const arr = [];
      for (let i = 0; i < state.questionArrText.length; i++) {
        const json = {};
        json.id = state.questionArrText[i].id;
        json.questionId = state.questionArrText[i].id;
        if (state.resource[i] instanceof Array) {
          json.answer = state.resource[i];
        } else {
          json.answer = [state.resource[i]];
        }
        if (json.answer === undefined) {
          json.answer = [''];
        }
        json.questionType = state.questionArrText[i].type;
        arr.push(json);
      }
      emit('handleToAnswer', arr);
    };

    // 下载通告
    const onDownload = async document => {
      if (state.canAnswer) {
        return false;
      }
      const req = {
        id: document
      };
      const downloadRes = await getDownloadFile(req);
      if (downloadRes.success && downloadRes.data) {
        location.href = downloadRes.data;
      }
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        model: state,
        ref_key: "ruleFormRef",
        ref: ruleFormRef
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.questionList, (questionItem, questionIndex) => {
          var _questionItem$attachm;
          return _openBlock(), _createElementBlock("div", {
            key: questionIndex,
            class: "execirse-block"
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(questionIndex + 1) + "、", 1), _createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(EXECIRSE_TYPE[questionItem.type]) + " ", 1), _createElementVNode("span", {
            innerHTML: questionItem.content
          }, null, 8, _hoisted_5)])]), (questionItem === null || questionItem === void 0 ? void 0 : (_questionItem$attachm = questionItem.attachments) === null || _questionItem$attachm === void 0 ? void 0 : _questionItem$attachm.length) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem === null || questionItem === void 0 ? void 0 : questionItem.attachments, (downloadItem, downloadIndex) => {
            return _openBlock(), _createElementBlock("div", {
              key: downloadIndex
            }, [_createElementVNode("div", {
              onClick: $event => onDownload(downloadItem.resourceId),
              class: "download-attachment"
            }, [_createVNode(_component_svg_icon, {
              class: "attachment-image",
              "icon-class": _unref(ATTACHMENT_ICON)[downloadItem.type],
              size: "16px",
              color: "#fff",
              style: _normalizeStyle({
                'background': _unref(ATTACHMENT_COLOR)[downloadItem.type]
              })
            }, null, 8, ["icon-class", "style"]), _createElementVNode("span", _hoisted_9, _toDisplayString(downloadItem.name), 1)], 8, _hoisted_8)]);
          }), 128))])) : _createCommentVNode("", true), questionItem.type != 'EXAM_QU_TYPE_OBJ_SELECT_MULTIPLE' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_form_item, {
            label: "",
            prop: "resource"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: state.resource[questionIndex],
              "onUpdate:modelValue": $event => state.resource[questionIndex] = $event,
              onChange: $event => changeOption($event, questionIndex),
              disabled: state.canAnswer
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem.objective, (option, index) => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: index,
                  label: option.id
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(NumToAbc(index)) + "、", 1), _createElementVNode("div", {
                    class: "option-content",
                    innerHTML: option.optionName
                  }, null, 8, _hoisted_13)])]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])]),
            _: 2
          }, 1024)])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_form_item, {
            label: "",
            prop: "resource"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
              modelValue: state.resource[questionIndex],
              "onUpdate:modelValue": $event => state.resource[questionIndex] = $event,
              onChange: $event => changeOption($event, questionIndex),
              disabled: state.canAnswer
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem.objective, (mulOption, index) => {
                return _openBlock(), _createBlock(_component_el_checkbox, {
                  key: index,
                  label: mulOption.id
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(NumToAbc(index)) + "、", 1), _createElementVNode("div", {
                    class: "option-content",
                    innerHTML: mulOption.optionName
                  }, null, 8, _hoisted_17)])]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])]),
            _: 2
          }, 1024)]))]);
        }), 128)), !state.canAnswer && __props.questionList.length > 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          class: "submit-button"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = $event => submitForm(ruleFormRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};